import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import * as S from './ProfileMenuLoginBtn.styles';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { getLoginUrlWithReturn } from '@/utils/helpers';

export const ProfileMenuLoginBtn = () => {
  const { asPath } = useRouter();
  const { t } = useTranslation();

  return (
    <CustomLink
      dataTestId={CommonTestIds.profileMenu.loginButton}
      href={getLoginUrlWithReturn(asPath, asPath)}
    >
      <S.ProfileMenuLoginButton>{t('common.enter')}</S.ProfileMenuLoginButton>
    </CustomLink>
  );
};
